import React, { useRef, useState } from 'react';

import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { bindActionCreators } from 'redux';
import * as Actions from 'redux/actions';
import moment from 'moment';

import SourceLogo from 'routes/Portfolio/Component/ActivityTab/TopicsTab/SourceLogo';

function TopicReadingArticle({
  article,
  history,
  actions,
  selectReading,
  linkToUrl = false,
}) {
  const ref = useRef(null);
  const [sourceName, setSourceName] = useState('');

  const url = article.sourceURL || article.url;

  function onClickReading(reading, isSummary) {
    if (isSummary) {
      selectReading(reading.pointId);
      return;
    }

    if (reading.readingFormat === 'text' && reading.pointId) {
      history.push(
        `/reading?readingId=${reading._id}&articleMediaCollectionId=${reading.pointId}`,
      );
    } else if (reading.readingFormat === 'url') {
      window.open(reading.url, '_blank');
    } else if (reading.readingFormat === 'pdf') {
      actions.getReadingPdfUrl(reading._id).then((res) => {
        window.open(
          `https://reader.averpoint.com/web/viewer.html?file=${encodeURIComponent(
            res,
          )}&articleMediaCollectionId=${reading.pointId}${
            reading.sourceName
              ? `&sourceName=${encodeURIComponent(reading.sourceName)}`
              : ''
          }`,
          '_blank',
        );
      });
    }
  }

  const getPopoverContent = () => (
    <div className="pt-2 mt-2 summary-links">
      <button
        type="button"
        className="btn-av-container py-1 av-blue"
        onClick={() => onClickReading(article, true)}
      >
        Student Reading Summary
      </button>
      <button
        type="button"
        className="btn-av-container py-1 av-blue"
        onClick={() => onClickReading(article)}
      >
        {article.readingFormat !== 'url'
          ? 'Go to AverPoint Reader'
          : `Go to article${sourceName ? ` on ${sourceName}` : ''}`}
      </button>
    </div>
  );

  const showHelperMessage = () => {
    actions.showPopover(
      ref,
      'bottom',
      null,
      <div className="d-flex">
        <SourceLogo
          url={url}
          showAverPointReaderLogo={['text', 'pdf'].includes(
            article.readingFormat,
          )}
        />
        {article.title}
      </div>,
      getPopoverContent(),
      null,
      null,
      [],
      false,
    );
  };

  return (
    <div className="d-flex align-items-start article-container title" ref={ref}>
      <SourceLogo
        url={url}
        setSourceName={setSourceName}
        isLoading={article.new && article.loading}
        showAverPointReaderLogo={['text', 'pdf'].includes(
          article.readingFormat,
        )}
        showLimitedToCourse
      />
      <div className="d-flex flex-column align-items-start ml-3">
        {linkToUrl ? (
          <a
            href={url}
            target="_blank"
            rel="noopener noreferrer"
            className="btn-av-container av-blue"
            style={{ textDecoration: 'none' }}
          >
            {article.title || article.url}
          </a>
        ) : (
          <button
            type="button"
            onClick={() => showHelperMessage()}
            className="btn-av-container av-blue"
          >
            {article.title || article.url}
          </button>
        )}
        {article.publishedAt && (
          <span className="gray-3 mt-1 font-size-12">
            {moment(article.publishedAt).format('MMM DD, YYYY')}
          </span>
        )}
      </div>
      {article.new && article.loading && (
        <div className="loader text-center ml-2 mt-1">
          <div
            className="fa fa-spin fa-spinner text-primary"
            style={{ fontSize: '20px' }}
          />
        </div>
      )}
    </div>
  );
}

function mapDispatchToProps(dispatch) {
  const actions = bindActionCreators(Actions, dispatch);
  return {
    actions,
    dispatch,
    selectReading: (readingId) => {
      dispatch(Actions.selectReading(readingId));
    },
  };
}

export default withRouter(
  connect(null, mapDispatchToProps)(TopicReadingArticle),
);
